import { useCallback, useEffect, useMemo } from "react";
import { IngredientDataType } from "../../../../config/enums/IngredientType.enum";
import { SupplierDataShape } from "../supplierRegister.types";
import { resolveIngredientDataType } from "../supplierRegister.utils";

interface UseSupplierDataTypeParams {
  supplierData: SupplierDataShape;
  setSupplierData: React.Dispatch<React.SetStateAction<SupplierDataShape>>;
  salesUnitData?: SupplierIngredientDetailsLike;
  supplierAsUser: boolean;
  currentDataType?: (type: string) => void;
}

interface SupplierIngredientDetailsLike {
  data_type?: string;
}

export const useSupplierDataType = ({
  supplierData,
  setSupplierData,
  salesUnitData,
  supplierAsUser,
  currentDataType
}: UseSupplierDataTypeParams) => {
  const fallbackDataType = supplierAsUser
    ? IngredientDataType.SUPPLIER
    : IngredientDataType.USER;

  const effectiveDataType = useMemo(
    () =>
      resolveIngredientDataType({
        salesDataType: salesUnitData?.data_type,
        supplierDataType: supplierData?.supplier_data?.dataType,
        fallback: fallbackDataType
      }),
    [salesUnitData?.data_type, supplierData?.supplier_data?.dataType, fallbackDataType]
  );

  const setDataType = useCallback(
    (type: string) => {
      setSupplierData(prev => ({
        ...prev,
        supplier_data: {
          ...prev.supplier_data,
          dataType: type
        }
      }));
      currentDataType?.(type);
    },
    [currentDataType, setSupplierData]
  );

  useEffect(() => {
    currentDataType?.(effectiveDataType);
  }, [currentDataType, effectiveDataType]);

  return {
    effectiveDataType,
    setDataType
  };
};
